<template>
  <div>
    <transaction-details  :title="$t('details') | capitalize" v-model="showDetails" :data="details"/>
    <link-expenses
      v-model="expenseLinkSidebar"
      :transaction="transaction"
      :account="accountData"
      @submit="submit"
    />
    <base-loading :visible="isLoading" />
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4 md:col-span-3 md:col-start-0 xs:col-start-1">
        <vs-input :value="accountData.ClientName" disabled class="w-full" />
      </div>
      <div class="col-span-4 md:col-span-2 md:col-start-4 xs:col-start-1">
        <vs-input
          :value="'*********' + accountData.account_suffix"
          disabled
          class="w-full"
        />
      </div>
      <div class="col-span-4 md:col-span-2 md:col-start-6 xs:col-start-1">
        <vs-input
          :value="reportData.transaction_reference"
          disabled
          class="w-full"
        />
      </div>
      <div class="col-span-12 md:col-span-1 md:col-start-9 xs:col-start-1">
       <vs-button class="w-full" :disabled="previous === null" @click="changeReport(previous)">{{ $t('previous') | capitalize }}</vs-button>
      </div>
      <div class="col-span-12 md:col-span-2 md:col-start-10 xs:col-start-1">
        <search-input v-model="search" @search="onSearch" @clear="onSearch" class="w-full" />
      </div>
       <div class="col-span-12 md:col-span-1 md:col-start-12 xs:col-start-1">
       <vs-button class="w-full" :disabled="next === null" @click="changeReport(next)">{{ $t('next') | capitalize }}</vs-button>
      </div>

      <div class="col-span-full col-start-1">
        <report-transactions-table
          :items="items"
          @loadMore="loadMore"
          @linkExpenses="onlinkExpenses"
          @sortChanged="onSortChanged"
          @details="onDetails"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifier } from '@/composables/useNotifier'
import { useReportTransactions } from '../../composables/useReportTransactions'
import { useNavigator } from '@/composables/useNavigator'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'
import ReportTransactionsTable from './components/ReportTransactionsTable'
import TransactionDetails from './components/TransactionDetails'
import LinkExpenses from './components/LinkExpenses'
const { goTo, getParam } = useNavigator()
const { notify } = useNotifier()
const reportTransactions = useReportTransactions()
const accountData = computed(() => reportTransactions.state.account)
const reportData = computed(() => reportTransactions.state.report)
const items = computed(() => reportTransactions.state.items)
const currentPage = computed(() => reportTransactions.state.currentPage)
const lastPage = computed(() => reportTransactions.state.lastPage)
const isLoading = computed(() => reportTransactions.state.loading)
const previous = computed(() => reportTransactions.state.previous)
const next = computed(() => reportTransactions.state.next)
const search = ref('')
const sort = ref({})
const report = getParam('report')
const showDetails = ref(false)
const details = ref([])
const loadData = async (params = {}) => {
  const payload = {
    page: reportTransactions.state.currentPage || 1,
    report: report.value,
    search: search.value,
    column: sort.value.column,
    order: sort.value.order,
    ...params,
  }
  const result = await reportTransactions.getReportTransactions(payload)
  if (!result.success)
    notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
  if (currentPage.value >= lastPage.value) return
  const newPage = reportTransactions.state.currentPage + 1
  await loadData({ page: newPage })
}

const onSearch = async () => {
  await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
  sort.value.column = sortData.key
  sort.value.order = sortData.order
  await loadData({
    column: sort.value.column,
    order: sort.value.order,
    page: 1,
  })
}

// Link Expenses
const expenseLinkSidebar = ref(false)
const transaction = ref({})

const onlinkExpenses = (row) => {
  expenseLinkSidebar.value = true
  transaction.value = { ...row }
}

const submit = async (payload) => {
  const result = await reportTransactions.linkExpenses(payload)
  if (!result.success) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  const idx = reportTransactions.state.items.findIndex(
    (el) => el.id === payload.transactionId
  )
  if (idx !== -1) {
    reportTransactions.state.items[idx].status = result.response.item
  }
  expenseLinkSidebar.value = false
  notify({ title: 'success', text: 'message_update', color: 'success' })
}

const onDetails = async(row) => {
  const payload = { transactionId:row.id}
  const result = await reportTransactions.getTransactionDetails(payload)
  if (!result.success) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  details.value = [...result.response.transactions ]
  showDetails.value = true
}

const changeReport = (id) => {
    goTo({ name: 'hsbc-bank-account-report-transactions', params: { report: id } })
    loadData()
}


onMounted(() => loadData())
</script>
